import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['infogenesis', 'omnivore', 'selected', 'form', 'infogenesisForm', 'checktypeDisplayValue', 'simphony', 'infogenesisServer12']
  static values = { restaurantType: String }

  changed(event) {
    this.restaurantTypeValue = event.target.value
  }

  restaurantTypeValueChanged(_value, previousValue) {
    // If the previous value was infogenesis, we need to move the infogenesis form back to the original location.
    if (previousValue === 'infogenesis_tpg' || previousValue === 'infogenesis_atpg') {
      this.infogenesisFormTarget.appendChild(this.infogenesisTarget);
    }

    if (previousValue === 'simphony_cloud') {
      this.infogenesisFormTarget.appendChild(this.simphonyTarget);
    }

    if (previousValue === 'infogenesis_server12') {
      this.infogenesisFormTarget.appendChild(this.infogenesisServer12Target);
    }

    this.insert()
  }

  insert() {
    const formInsert = this.formTarget
    const restaurantType = this.restaurantTypeValue
    formInsert.innerHTML = '';

    if (restaurantType === 'infogenesis_atpg' || restaurantType === 'infogenesis_tpg') {
      // Don't clone the IG form. Because of Select2 we need to move this chunk of dom.
      formInsert.appendChild(this.infogenesisTarget);
    } else if (restaurantType === 'infogenesis_server12') {
      // Don't clone the IG Server12 form. Because of Select2 we need to move this chunk of dom.
      formInsert.appendChild(this.infogenesisServer12Target);
    } else if (restaurantType === 'simphony_cloud') {
      // Don't clone the Simphony form. Because of Select2 we need to move this chunk of dom.
      formInsert.appendChild(this.simphonyTarget);
    } else if (restaurantType === 'omnivore') {
      // Don't clone the Omnivore form. Because of Select2 we need to move this chunk of dom.
      formInsert.appendChild(this.omnivoreTarget);
    }
  }
}
